
import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { requestAuth } from "../components/services/RequestService";

ChartJS.register(ArcElement, Tooltip, Legend);

export function GraficChart({ values, year }) {
  const [datosBackend, setDatosBackend] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let activo = true;

    const obtenerDatos = async () => {
      setLoading(true);
      setError(false);
      setDatosBackend(null);

      try {
        const gestion = Number(year);

        const response = await requestAuth(
          "GET",
          "/v2/ProcedureReport/chart",
          {},
          { gestion }
        );

        if (activo) {
          console.log("RESPUESTA REAL DEL BACKEND:", response.data);
          setDatosBackend(response.data);
        }
      } catch (err) {
        if (activo) {
          console.error("Error al consultar los trámites:", err);
          setError(true);
        }
      } finally {
        if (activo) {
          setLoading(false);
        }
      }
    };

    obtenerDatos();

    return () => {
      activo = false;
    };
  }, [year]);

  if (loading) {
    return <p className="text-center">Cargando trámites...</p>;
  }

  if (error) {
    return (
      <p className="text-center text-red-500">
        No se pudieron cargar los trámites.
      </p>
    );
  }

  // Pendiente de confirmar los nombres exactos
  // de las propiedades que devuelve el backend.
  const pendientes = Number(datosBackend?.pending ?? 0);
  const completos = Number(datosBackend?.completed ?? 0);

  const data = {
    labels: ["Pendientes", "Completos"],
    datasets: [
      {
        label: "Total de trámites",
        data: [pendientes, completos],
        backgroundColor: [
          "rgba(5, 110, 252, 0.9)",
          "rgba(2, 232, 255, 0.7)",
        ],
        borderWidth: 3,
        cutout: "50%",
      },
    ],
  };

  return <Doughnut data={data} />;
}
